export default "__VITE_ASSET__CIQSzAkB__"